import React from 'react';
import { ProviderPercentContext } from './types';

// @ts-ignore
export default React.createContext<ProviderPercentContext>();